// In-app browsers (Instagram, Facebook, TikTok, Twitter, etc.) sandbox
// the auth flow in ways that often break Supabase magic-link redirects,
// OAuth pop-ups, and password autofill. Nudge those users to open
// pantryioapp.com in their real browser before they try to sign up or
// in — fixing it later (after they hit a confusing failure) is much
// worse for conversion than a clear up-front banner.
//
// Detection is user-agent based, which is best-effort: spoofed UAs and
// new in-app browsers will slip through. Don't make this load-bearing
// for security — it's purely a UX hint.

const IN_APP_BROWSER_UA = /FBAN|FBAV|Instagram|TikTok|Twitter|Line|WhatsApp/i

function isInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') return false
  return IN_APP_BROWSER_UA.test(navigator.userAgent)
}

export function InAppBrowserBanner() {
  if (!isInAppBrowser()) return null

  return (
    <div className="rounded-2xl bg-cream-warm border border-border-sand px-4 py-3 mb-5">
      <p className="text-[10px] uppercase tracking-[0.18em] font-medium text-terracotta">
        Heads up
      </p>
      <p className="font-serif text-[13px] italic text-ink leading-[1.45] mt-1">
        For the best experience, tap <span className="not-italic font-medium">•••</span> and choose <span className="not-italic font-medium">"Open in Browser"</span>.
      </p>
    </div>
  )
}
